<template>
    <div style="width:100%;">

        <nav>

            <v-app-bar color="indigo" dark fixed app>
                <v-app-bar-nav-icon class="grey--text" @click="drawer = !drawer"></v-app-bar-nav-icon>
                <v-toolbar-title class="text-uppercase grey--text">
                    <span class="font-weight-light">ACCOUNTABLE PERSONS</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>


                <v-btn  text color="grey"
                    @click.prevent="addDoc()">
                    <v-icon right>add_box</v-icon>
                </v-btn>

                <v-btn  text color="grey"
                    @click.prevent="refresh()">
                    <v-icon right>refresh</v-icon>
                </v-btn>

                <v-btn text color="grey"
                    @click.prevent="signOut">
                    <span></span>
                    <v-icon right>exit_to_app</v-icon>
                </v-btn>

            </v-app-bar> 

            <NavDraw :drawer="drawer" ></NavDraw>

        </nav>
        <v-container>

            <div>

                <v-layout column>
                    <v-flex>
                        <v-layout row class="row-header">
                            <v-flex xs10 md10 class="col-header">Accountable Persons</v-flex>
                            <v-flex xs2 md1 v-if="updateMode != ''" class="col-header"></v-flex>

                        </v-layout>
                    </v-flex>
                    <v-flex>
                        <v-layout v-if="updateMode == 'add'" row>
                            <v-flex xs10 md10>
                                <v-text-field  class="mr-2"
                                    v-model="newDoc.accountablePerson"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs2 md2>
                                <v-layout row>
                                    <v-flex shrink>
                                        <v-btn dark small color="pink" fab  class="mr-2"
                                            @click.prevent="saveAdd()">
                                            <v-icon>save</v-icon>
                                        </v-btn>

                                    </v-flex>
                                    <v-flex shrink>
                                        <v-btn dark small color="pink" fab  
                                            @click.prevent="cancelAdd()">
                                            <v-icon>undo</v-icon>
                                        </v-btn>

                                    </v-flex>
                                </v-layout>


                            </v-flex>

                        </v-layout>

                    </v-flex>
                    <v-flex v-for="(doc,i) in docs" :key="i">

                        <v-layout v-if="updateMode == 'edit' && doc.active" row>
                            <v-flex xs10 md10>
                                <v-text-field class="mr-2"
                                    v-model="activeDoc.accountablePerson"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs2 md2>
                                <v-layout row>
                                    <v-flex shrink>
                                        <v-btn dark small color="pink" fab  class="mr-2"
                                            @click.prevent="saveUpdate(doc)">
                                            <v-icon>save</v-icon>
                                        </v-btn>

                                    </v-flex>
                                    <v-flex shrink>
                                        <v-btn dark small color="pink" fab  
                                            @click.prevent="cancelUpdate(doc)">
                                            <v-icon>undo</v-icon>
                                        </v-btn>

                                    </v-flex>
                                </v-layout>


                            </v-flex>

                        </v-layout>

                        <v-layout v-else row>
                            <v-flex xs10 md10 class="doc-key" @click="setUpdateMode(doc)">
                                {{ doc.accountablePerson }}
                            </v-flex>
                            <v-flex xs2 md2 v-if="updateMode == 'edit'"></v-flex>
                        </v-layout>

                    </v-flex>

                </v-layout>

            </div>

        </v-container>
        <v-overlay :value="overlay">
        <v-progress-circular
            indeterminate
            color="purple"
            size="200"
        ></v-progress-circular>
        </v-overlay>

    </div>
</template>

<script>
import NavDraw from '@/components/NavDraw'
import {mapState, mapActions} from 'vuex'
//import DocFileDetail from './DocFileDetail'

const fb = require('../../firebaseConfig.js')

export default {
    components:{NavDraw},
    data(){
        return {
            drawer:false,
            docs:[],
            activeDoc:null,
            updateMode:'',
            newDoc:{
                accountablePerson:'',
            },
            overlay:false
        }
    },
    computed:{
        ...mapState(['accountablePersons','currentUser'])
    },
    methods:{
        ...mapActions(['fetchaccountablePersons','setCurrentUser']),
        refresh(){
            //this.$store.dispatch('VIDEOS_GET');

            if (this.drawer){
                this.drawer = false
            }

            this.updateMode = ''
            
            this.setDocs()
            
        },
        addDoc(){
           
            if (this.drawer){
                this.drawer = false
            }

            if (this.updateMode != ''){
                return
            }

            this.updateMode = 'add'

        },
        cancelAdd(){
            this.updateMode = ''
            this.newDoc = {
                accountablePerson:'',
            }
        },
        saveAdd(){

            fb.accountablePersonsCollection.add({
                accountablePerson:this.newDoc.accountablePerson,
                hdType:this.currentUser.hdType
            })
            .then((docRef)=>{
                console.log("docRef ", docRef);
                if (docRef){
                    this.$store.state.accountablePersons.push({
                        id:docRef.id,
                        accountablePerson:this.newDoc.accountablePerson,
                        hdType:this.currentUser.hdType,
                    })
                    this.docs.push({
                        id:docRef.id,
                        accountablePerson:this.newDoc.accountablePerson,
                        hdType:this.currentUser.hdType,
                        active:false
                    })
                }
                this.updateMode = ''
            })
            .catch(error=>console.log(error))

        },
        setUpdateMode(doc){

            if (this.drawer){
                this.drawer = false
            }

            if (this.updateMode != ''){
                return
            }
            this.updateMode = 'edit'
            doc.active = true
            this.activeDoc = {...doc}
        },
        cancelUpdate(doc){
            doc.active = false
            this.updateMode = ''
        },
        saveUpdate(doc){

            fb.accountablePersonsCollection.doc(doc.id).update({
                accountablePerson:this.activeDoc.accountablePerson
            })

            doc.accountablePerson = this.activeDoc.accountablePerson

            this.updateMode = ''

        },
        signOut(){

            let self = this;
            fb.auth.signOut().then(function() {
                self.$router.push({name:'Login'})
            }).catch(function(error) {
                // An error happened.
                console.log(error.message)
            });

        },

        setDocs(){

            this.docs = []
            this.overlay = true

            let accountablePersons = []
            fb.accountablePersonsCollection.where("hdType","==",this.currentUser.hdType).get()
            .then(docs=>{
                docs.forEach(doc=>{
                    accountablePersons.push({
                        id:doc.id,
                        accountablePerson:doc.data().accountablePerson,
                        hdType:doc.data().hdType
                    });
                });
                accountablePersons.sort((a,b)=>(a.accountablePerson > b.accountablePerson) ? 1 : -1);
                this.$store.state.accountablePersons = [...accountablePersons]
                this.docs = [...accountablePersons]

                this.docs.forEach(doc=>{
                    doc.active = false
                })
                this.overlay = false

            })


        }

    },
    mounted(){

        console.log("accountablePersons mounted!");
     

    },
    created(){
        console.log("accountablePersons Created")

        if ( !this.$store.state.currentUser || this.$store.state.currentUser.userID == ''){

            let currentUser = JSON.parse(localStorage.getItem('currentUser'))

            if (currentUser){
                this.setCurrentUser(currentUser)
            }else{
                this.$router.push('/')
            }
            
        }

        this.updateMode = '';

        if (this.$store.state.accountablePersons.length == 0){
            this.setDocs()
        }else{

            this.docs = [...this.$store.state.accountablePersons]

            this.docs.forEach(doc=>{
                doc.active = false
            })

        }


    },

}
</script>

<style  scoped>
.doc-key{
    cursor: pointer;
}
.row-header .col-header {
    background-color:black;
    color:white;
    font-weight: bold;
    text-align: center;
    padding-bottom: 5px;
    padding-top: 5px;
    margin-top: 10px;
    margin-bottom: 5px;
}

.row-header .col-header2 {
    background-color:lightgray;
    color:black;
    font-weight: bold;
    font-size:medium;
    text-align: center;
}

.file-icon{
    width:40px;
    height: 40px;
    max-width: 40px;
    max-height: 40px;
}

.dv-clear{
    cursor: pointer;
}
.label-text{
    font-weight: bold;
}
.dv-message{
    font-weight: bold;
    font-size: 1.2rem;
    color:blue;
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.errorMessage{
    color:red;
    border: 2px solid red;
    padding: 10px;
}

.emp-clear-status{
    color:blue;
    border: 2px solid red;
    font-weight: bold;
    padding: 5px;
}
</style>